import type { BusinessType } from '@app/shared';

/**
 * Большой словарь автоперевода «Другой услуги» (22.09.2026), дополняет EXTRA_PHRASES
 * из serviceExample.ts: только пары, которых там нет. В выпадающий список не попадает.
 * Узбекский — латиница: ʻ (U+02BB) в oʻ/gʻ, ʼ (U+02BC) в taʼmir/maʼlumot.
 * `// ?` — перевод стоит проверить носителю; правится здесь же, код не трогается.
 */
export const MORE_PHRASES: Readonly<Record<BusinessType, readonly (readonly [string, string])[]>> = {
  barbershop: [
    ['Стрижка ножницами', 'Qaychi bilan soch olish'],
    ['Стрижка насадкой', 'Nasadka bilan soch olish'], // ?
    ['Стрижка ножницами и машинкой', 'Qaychi va mashinkada soch olish'],
    ['Стрижка с мытьём головы', 'Bosh yuvish bilan soch olish'],
    ['Экспресс-стрижка', 'Tezkor soch turmagi'],
    ['Бокс', 'Boks'],
    ['Полубокс', 'Yarim boks'],
    ['Андеркат', 'Anderkat'],
    ['Кроп', 'Krop'],
    ['Канадка', 'Kanadka'],
    ['Площадка', 'Ploshchadka'], // ?
    ['Скин фейд', 'Skin feyd'],
    ['Тейпер', 'Teyper'],
    ['Стрижка с переходом', 'Oʻtishli soch turmagi'], // ?
    ['Стрижка длинных волос', 'Uzun sochni qirqish'],
    ['Стрижка для школьника', 'Maktab oʻquvchisi uchun soch turmagi'],
    ['Стрижка для пожилых', 'Keksalar uchun soch turmagi'],
    ['Детская стрижка машинкой', 'Bolalar sochini mashinkada olish'],
    ['Стрижка жениха', 'Kuyov soch turmagi'],
    ['Подготовка жениха', 'Kuyovni tayyorlash'],
    ['Стрижка чёлки', 'Chyolka qirqish'],
    ['Бритьё головы', 'Boshni ustara bilan qirish'],
    ['Бритьё шеи', 'Boʻyinni qirish'],
    ['Бритьё бороды', 'Soqolni toʻliq olish'],
    ['Стрижка бороды машинкой', 'Soqolni mashinkada olish'],
    ['Стрижка бороды и усов', 'Soqol va moʻylov turmagi'],
    ['Моделирование бороды', 'Soqolni modellash'],
    ['Контур бороды', 'Soqol konturi'],
    ['Окантовка', 'Kantovka'], // ?
    ['Окантовка бороды', 'Soqol kantovkasi'], // ?
    ['Укладка бороды', 'Soqolni turmaklash'],
    ['Тонирование бороды', 'Soqolni tonlash'],
    ['Тонирование седины', 'Oq sochni tonlash'],
    ['Окрашивание усов', 'Moʻylov boʻyash'],
    ['Укладка с воском', 'Mum bilan turmaklash'], // ?
    ['Стайлинг', 'Stayling'],
    ['Химическая завивка', 'Sochni kimyoviy jingalaklash'],
    ['Выпрямление волос', 'Sochni tekislash'],
    ['Пробор бритвой', 'Ustara bilan farq ochish'], // ?
    ['Рисунок на волосах', 'Sochga naqsh chizish'],
    ['Удаление волос в носу', 'Burun tuklarini olish'],
    ['Удаление волос в ушах', 'Quloq tuklarini olish'],
    ['Коррекция бровей', 'Qosh tuzatish'],
    ['Чёрная маска', 'Qora niqob'],
    ['Маска для лица', 'Yuz niqobi'],
    ['Пилинг для лица', 'Yuz pilingi'],
    ['Горячее полотенце', 'Issiq sochiq'],
    ['Массаж головы', 'Bosh massaji'],
    ['Уход за кожей головы', 'Bosh terisi parvarishi'],
    ['Мужской маникюр', 'Erkaklar manikyuri'],
    ['Мужской педикюр', 'Erkaklar pedikyuri'],
    ['Комплекс', 'Kompleks'],
    ['Выезд мастера на дом', 'Ustani uyga chaqirish'],
  ],
  beauty: [
    ['Маникюр без покрытия', 'Qoplamasiz manikyur'],
    ['Аппаратный маникюр', 'Apparat manikyur'],
    ['Комбинированный маникюр', 'Kombinatsiyalangan manikyur'],
    ['Мужской маникюр', 'Erkaklar manikyuri'],
    ['Детский маникюр', 'Bolalar manikyuri'],
    ['Френч', 'Frensh'],
    ['Дизайн ногтей', 'Tirnoq dizayni'],
    ['Укрепление ногтей', 'Tirnoqni mustahkamlash'],
    ['Коррекция наращенных ногтей', 'Uzaytirilgan tirnoqlarni korreksiya qilish'],
    ['Снятие гель-лака', 'Gel-lakni olib tashlash'],
    ['Педикюр с покрытием', 'Qoplamali pedikyur'],
    ['Аппаратный педикюр', 'Apparat pedikyur'],
    ['Покрытие гель-лаком на ногах', 'Oyoqqa gel-lak qoplash'],
    ['Парафинотерапия', 'Parafinoterapiya'],
    ['Мужская стрижка', 'Erkaklar soch turmagi'],
    ['Стрижка кончиков', 'Soch uchlarini olish'],
    ['Стрижка горячими ножницами', 'Issiq qaychi bilan qirqish'],
    ['Мытьё головы', 'Bosh yuvish'],
    ['Укладка феном', 'Fen bilan turmaklash'],
    ['Локоны', 'Jingalak soch turmagi'],
    ['Плетение кос', 'Soch oʻrish'],
    ['Наращивание волос', 'Soch uzaytirish'],
    ['Окрашивание корней', 'Soch ildizini boʻyash'],
    ['Окрашивание в один тон', 'Bir tonda boʻyash'],
    ['Сложное окрашивание', 'Murakkab boʻyash'],
    ['Балаяж', 'Balayaj'],
    ['Шатуш', 'Shatush'],
    ['Омбре', 'Ombre'],
    ['Блондирование', 'Sochni oqartirish (blondlash)'], // ?
    ['Ботокс для волос', 'Soch uchun botoks'],
    ['Кератиновое выпрямление', 'Keratin bilan tekislash'],
    ['Химическая завивка', 'Sochni kimyoviy jingalaklash'],
    ['Уход за волосами', 'Soch parvarishi'],
    ['Дневной макияж', 'Kunduzgi makiyaj'],
    ['Макияж на выпускной', 'Bitiruv kechasi uchun makiyaj'],
    ['Макияж для невесты', 'Kelin makiyaji'],
    ['Образ невесты', 'Kelin obrazi'],
    ['Причёска для невесты', 'Kelin soch turmagi'],
    ['Выезд мастера на дом', 'Ustani uyga chaqirish'],
    ['Архитектура бровей', 'Qosh arxitekturasi'],
    ['Окрашивание бровей хной', 'Qoshni xina bilan boʻyash'],
    ['Коррекция и окрашивание бровей', 'Qosh tuzatish va boʻyash'],
    ['Окрашивание ресниц', 'Kiprik boʻyash'],
    ['Снятие ресниц', 'Kipriklarni olib tashlash'],
    ['Коррекция ресниц', 'Kiprik korreksiyasi'],
    ['Перманентный макияж', 'Permanent makiyaj'],
    ['Татуаж бровей', 'Qosh tatuaji'],
    ['Татуаж губ', 'Lab tatuaji'],
    ['Пудровые брови', 'Pudra usulida qosh'], // ?
    ['Микроблейдинг', 'Mikrobleyding'],
    ['Восковая депиляция', 'Mum bilan depilyatsiya'],
    ['Лазерная эпиляция', 'Lazer epilyatsiya'],
    ['Шугаринг бикини', 'Bikini shugaring'],
    ['Депиляция ног', 'Oyoq depilyatsiyasi'],
    ['Депиляция подмышек', 'Qoʻltiq depilyatsiyasi'],
    ['Депиляция лица', 'Yuz depilyatsiyasi'],
    ['Удаление волос нитью', 'Ip bilan tuk olish'],
    ['Механическая чистка лица', 'Yuzni mexanik tozalash'],
    ['Ультразвуковая чистка лица', 'Yuzni ultratovush bilan tozalash'],
    ['Массаж лица', 'Yuz massaji'],
    ['Маска для лица', 'Yuz niqobi'],
    ['Биоревитализация', 'Biorevitalizatsiya'],
    ['Мезотерапия', 'Mezoterapiya'],
    ['Ботокс', 'Botoks'],
    ['Увеличение губ', 'Lab kattalashtirish'],
    ['Контурная пластика', 'Kontur plastika'],
  ],
  dental: [
    ['Первичный осмотр', 'Birlamchi koʻrik'],
    ['Консультация ортодонта', 'Ortodont maslahati'],
    ['Консультация хирурга', 'Stomatolog-jarroh maslahati'],
    ['Консультация ортопеда', 'Ortoped maslahati'],
    ['Детская стоматология', 'Bolalar stomatologiyasi'],
    ['Чистка зубов', 'Tish tozalash'],
    ['Ультразвуковая чистка зубов', 'Tishlarni ultratovush bilan tozalash'],
    ['Чистка Air Flow', 'Air Flow bilan tozalash'],
    ['Удаление зубного налёта', 'Tish karashini tozalash'],
    ['Гигиена полости рта', 'Ogʻiz boʻshligʻi gigiyenasi'],
    ['Фторирование', 'Ftorlash'],
    ['Серебрение зубов', 'Tishlarni kumushlash'],
    ['Герметизация фиссур', 'Fissuralarni germetizatsiya qilish'],
    ['Лечение зуба', 'Tish davolash'],
    ['Световая пломба', 'Svetovoy plomba'], // ?
    ['Временная пломба', 'Vaqtinchalik plomba'],
    ['Постоянная пломба', 'Doimiy plomba'],
    ['Замена пломбы', 'Plombani almashtirish'],
    ['Реставрация зуба', 'Tishni restavratsiya qilish'],
    ['Художественная реставрация', 'Badiiy restavratsiya'],
    ['Удаление нерва', 'Nervni olib tashlash'],
    ['Лечение периодонтита', 'Periodontitni davolash'],
    ['Лечение пародонтоза', 'Parodontozni davolash'],
    ['Лечение стоматита', 'Stomatitni davolash'],
    ['Лечение флюса', 'Flyusni davolash'],
    ['Кюретаж', 'Kyuretaj'],
    ['Шинирование зубов', 'Tishlarni shinalash'],
    ['Лечение молочных зубов', 'Sut tishlarini davolash'],
    ['Удаление молочного зуба', 'Sut tishini sugʻurish'],
    ['Сложное удаление зуба', 'Tishni murakkab sugʻurish'],
    ['Удаление кисты', 'Kistani olib tashlash'],
    ['Пластика уздечки', 'Til yuganchasi plastikasi'], // ?
    ['Обезболивание', 'Ogʻriqsizlantirish'],
    ['Лечение под наркозом', 'Narkoz ostida davolash'],
    ['Металлокерамическая коронка', 'Metallokeramik toj'],
    ['Циркониевая коронка', 'Sirkoniy toj'],
    ['Керамическая коронка', 'Keramik toj'],
    ['Временная коронка', 'Vaqtinchalik toj'],
    ['Вкладка', 'Vkladka'], // ?
    ['Штифт', 'Shtift'],
    ['Мост', 'Koʻprik protez (most)'],
    ['Съёмный протез', 'Olinadigan protez'],
    ['Бюгельный протез', 'Byugel protez'],
    ['Протез на имплантах', 'Implant ustidagi protez'],
    ['Установка импланта', 'Implant oʻrnatish'],
    ['Синус-лифтинг', 'Sinus-lifting'],
    ['Костная пластика', 'Suyak plastikasi'],
    ['Установка брекетов', 'Breket oʻrnatish'],
    ['Снятие брекетов', 'Breketlarni olib tashlash'],
    ['Коррекция брекетов', 'Breket korreksiyasi'],
    ['Элайнеры', 'Elaynerlar'],
    ['Капа', 'Kapa'],
    ['Ретейнер', 'Reteyner'],
    ['Домашнее отбеливание', 'Uyda oqartirish'],
    ['Лазерное отбеливание', 'Lazer bilan oqartirish'],
    ['Прицельный снимок', 'Bitta tish surati'], // ?
    ['Компьютерная томография', 'Kompyuter tomografiyasi'],
  ],
  massage: [
    ['Классический массаж', 'Klassik massaj'],
    ['Общий массаж', 'Umumiy massaj'],
    ['Массаж шейно-воротниковой зоны', 'Boʻyin-yelka sohasi massaji'],
    ['Массаж шеи', 'Boʻyin massaji'],
    ['Массаж спины и шеи', 'Orqa va boʻyin massaji'],
    ['Массаж поясницы', 'Bel massaji'],
    ['Массаж рук', 'Qoʻl massaji'],
    ['Массаж живота', 'Qorin massaji'],
    ['Массаж ступней', 'Oyoq tagi massaji'],
    ['Висцеральный массаж', 'Visseral massaj'],
    ['Массаж при остеохондрозе', 'Osteoxondrozda massaj'],
    ['Массаж при грыже', 'Churrada massaj'],
    ['Массаж для беременных', 'Homiladorlar uchun massaj'],
    ['Массаж для грудничков', 'Chaqaloqlar massaji'],
    ['Точечный массаж', 'Nuqtali massaj'],
    ['Медовый массаж', 'Asal massaji'],
    ['Вакуумный массаж', 'Vakuum massaj'],
    ['Массаж горячими камнями', 'Issiq tosh massaji'],
    ['Стоун-терапия', 'Stoun-terapiya'],
    ['Аромамассаж', 'Aromamassaj'],
    ['Массаж с маслами', 'Moy bilan massaj'],
    ['Балийский массаж', 'Bali massaji'],
    ['Японский массаж лица', 'Yapon yuz massaji'],
    ['Скульптурный массаж лица', 'Yuzning skulptura massaji'],
    ['Буккальный массаж', 'Bukkal massaj'],
    ['Массаж в четыре руки', 'Toʻrt qoʻlda massaj'],
    ['Парный массаж', 'Juftlik massaji'],
    ['Моделирующий массаж', 'Qomatni shakllantiruvchi massaj'],
    ['Коррекция фигуры', 'Qomatni tuzatish'],
    ['Курс массажа', 'Massaj kursi'],
    ['Абонемент на массаж', 'Massaj abonementi'],
    ['Кинезиотейпирование', 'Kinezioteyping'],
    ['Иглоукалывание', 'Igna bilan davolash'],
    ['Рефлексотерапия', 'Refleksoterapiya'],
    ['Остеопатия', 'Osteopatiya'],
    ['Вправление позвонков', 'Umurtqani joyiga solish'],
    ['Вправление суставов', 'Boʻgʻimlarni joyiga solish'],
    ['Банки', 'Banka qoʻyish'],
    ['Кровопускание', 'Qon chiqarish'], // ?
    ['Гирудотерапия', 'Zuluk bilan davolash'],
    ['Хамам', 'Hammom'],
    ['Турецкий хамам', 'Turk hammomi'],
    ['Пенный массаж', 'Koʻpikli massaj'],
    ['Пилинг кесе', 'Kese bilan tanani tozalash'], // ?
    ['Баня', 'Bugʻ hammomi'], // ?
    ['Финская сауна', 'Fin saunasi'],
    ['Скраб для тела', 'Tana skrabi'],
    ['Пилинг тела', 'Tana pilingi'],
    ['Шоколадное обёртывание', 'Shokoladli oʻrash'],
    ['Обёртывание водорослями', 'Suvoʻtli oʻrash'],
    ['Прессотерапия', 'Pressoterapiya'],
    ['SPA-программа', 'SPA dasturi'],
    ['SPA для двоих', 'Ikki kishilik SPA'],
    ['Джакузи', 'Jakuzi'],
    ['Бассейн', 'Basseyn'],
  ],
  autoservice: [
    ['Замена масла в двигателе', 'Dvigatel moyini almashtirish'],
    ['Замена моторного масла', 'Motor moyini almashtirish'],
    ['Замена масляного фильтра', 'Moy filtrini almashtirish'],
    ['Замена воздушного фильтра', 'Havo filtrini almashtirish'],
    ['Замена салонного фильтра', 'Salon filtrini almashtirish'],
    ['Замена топливного фильтра', 'Yoqilgʻi filtrini almashtirish'],
    ['Замена тормозной жидкости', 'Tormoz suyuqligini almashtirish'],
    ['Замена тормозных дисков', 'Tormoz disklarini almashtirish'],
    ['Замена амортизаторов', 'Amortizatorlarni almashtirish'],
    ['Замена сцепления', 'Stsepleniyeni almashtirish'],
    ['Замена ремня генератора', 'Generator tasmasini almashtirish'],
    ['Замена цепи ГРМ', 'GRM zanjirini almashtirish'],
    ['Замена помпы', 'Pompani almashtirish'],
    ['Замена радиатора', 'Radiatorni almashtirish'],
    ['Замена шаровой опоры', 'Sharovoy oporani almashtirish'], // ?
    ['Замена сайлентблоков', 'Saylentbloklarni almashtirish'],
    ['Замена стоек стабилизатора', 'Stabilizator stoykalarini almashtirish'],
    ['Замена ступичного подшипника', 'Stupitsa podshipnigini almashtirish'], // ?
    ['Замена рулевых наконечников', 'Rul uchliklarini almashtirish'], // ?
    ['Замена лобового стекла', 'Old oynani almashtirish'],
    ['Замена ламп', 'Lampalarni almashtirish'],
    ['Техобслуживание', 'Texnik xizmat koʻrsatish'],
    ['Ремонт подвески', 'Podveska taʼmiri'],
    ['Ремонт рулевой рейки', 'Rul reykasini taʼmirlash'],
    ['Ремонт стартера', 'Starterni taʼmirlash'],
    ['Ремонт генератора', 'Generatorni taʼmirlash'],
    ['Капитальный ремонт двигателя', 'Dvigatelni kapital taʼmirlash'],
    ['Ремонт головки блока', 'Blok golovkasini taʼmirlash'], // ?
    ['Регулировка клапанов', 'Klapanlarni sozlash'],
    ['Чистка инжектора', 'Injektorni tozalash'],
    ['Чистка форсунок', 'Forsunkalarni tozalash'],
    ['Ремонт АКПП', 'Avtomat karobka taʼmiri'],
    ['Ремонт глушителя', 'Glushitelni taʼmirlash'],
    ['Ремонт печки', 'Pechka taʼmiri'],
    ['Ремонт электропроводки', 'Elektr simlarini taʼmirlash'],
    ['Регулировка фар', 'Faralarni sozlash'],
    ['Заправка фреона', 'Freon quyish'],
    ['Установка метана', 'Metan ballon oʻrnatish'],
    ['Установка пропана', 'Propan oʻrnatish'],
    ['Регулировка газа', 'Gazni sozlash'],
    ['Обслуживание газового оборудования', 'Gaz uskunasiga xizmat koʻrsatish'],
    ['Освидетельствование газового баллона', 'Gaz ballonini koʻrikdan oʻtkazish'], // ?
    ['Сварочные работы', 'Payvandlash ishlari'],
    ['Рихтовка', 'Rixtovka'],
    ['Ремонт бампера', 'Bamper taʼmiri'],
    ['Покраска бампера', 'Bamperni boʻyash'],
    ['Покраска детали', 'Detalni boʻyash'],
    ['Локальная покраска', 'Qisman boʻyash'],
    ['Полная покраска', 'Toʻliq boʻyash'],
    ['Удаление вмятин без покраски', 'Boʻyamasdan pachoqni tekislash'],
    ['Антикор', 'Antikor ishlov'],
    ['Керамика', 'Keramik qoplama'],
    ['Оклейка плёнкой', 'Plyonka yopishtirish'],
    ['Шумоизоляция', 'Shovqin izolyatsiyasi'],
    ['Тонировка стёкол', 'Oynalarni tonirovka qilish'],
    ['Снятие тонировки', 'Tonirovkani olib tashlash'],
    ['Ремонт скола', 'Oyna skolini taʼmirlash'], // ?
    ['Мойка кузова', 'Kuzov yuvish'],
    ['Комплексная мойка', 'Kompleks yuvish'],
    ['Мойка двигателя', 'Dvigatel yuvish'],
    ['Чистка салона', 'Salonni tozalash'],
    ['Ремонт шин', 'Shina taʼmiri'],
    ['Вулканизация', 'Vulkanizatsiya'],
    ['Прокатка дисков', 'Disk prokatkasi'],
    ['Установка сигнализации', 'Signalizatsiya oʻrnatish'],
    ['Установка магнитолы', 'Magnitola oʻrnatish'],
    ['Установка камеры заднего вида', 'Orqa koʻrinish kamerasini oʻrnatish'],
    ['Эвакуатор', 'Evakuator'],
  ],
  tutor: [
    ['Алгебра', 'Algebra'],
    ['Геометрия', 'Geometriya'],
    ['Курс математики', 'Matematika kursi'],
    ['Родной язык', 'Ona tili'],
    ['Родной язык и литература', 'Ona tili va adabiyot'],
    ['Урок узбекского', 'Oʻzbek tili darsi'],
    ['Урок географии', 'Geografiya darsi'],
    ['Урок информатики', 'Informatika darsi'],
    ['Французский язык', 'Fransuz tili'],
    ['Китайский язык', 'Xitoy tili'],
    ['Японский язык', 'Yapon tili'],
    ['Испанский язык', 'Ispan tili'],
    ['Курс английского', 'Ingliz tili kursi'],
    ['Разговорный английский', 'Soʻzlashuv ingliz tili'],
    ['Английский для детей', 'Bolalar uchun ingliz tili'],
    ['Английский для начинающих', 'Boshlovchilar uchun ingliz tili'],
    ['Грамматика английского', 'Ingliz tili grammatikasi'],
    ['Разговорный клуб', 'Soʻzlashuv klubi'],
    ['Подготовка к TOEFL', 'TOEFLga tayyorlov'],
    ['Подготовка к TOPIK', 'TOPIKka tayyorlov'],
    ['Подготовка к национальному сертификату', 'Milliy sertifikatga tayyorlov'],
    ['Подготовка к экзаменам', 'Imtihonlarga tayyorlov'],
    ['Подготовка к тестам', 'Testlarga tayyorlov'],
    ['Подготовка к олимпиаде', 'Olimpiadaga tayyorlov'],
    ['Подготовка в Президентскую школу', 'Prezident maktabiga tayyorlov'],
    ['Подготовка в специализированную школу', 'Ixtisoslashgan maktabga tayyorlov'],
    ['Подготовка к аттестации', 'Attestatsiyaga tayyorlov'],
    ['Начальные классы', 'Boshlangʻich sinflar'],
    ['Помощь с домашним заданием', 'Uy vazifasiga yordam'],
    ['Обучение чтению', 'Oʻqishni oʻrgatish'],
    ['Скорочтение', 'Tez oʻqish'],
    ['Каллиграфия', 'Husnixat'],
    ['Ментальная арифметика', 'Mental arifmetika'],
    ['Логопед', 'Logoped'],
    ['Занятия с логопедом', 'Logoped bilan mashgʻulot'],
    ['Развивающие занятия', 'Rivojlantiruvchi mashgʻulotlar'],
    ['Робототехника', 'Robototexnika'],
    ['Программирование на Python', 'Python dasturlash'],
    ['Веб-разработка', 'Veb-dasturlash'],
    ['Компьютерная грамотность', 'Kompyuter savodxonligi'],
    ['Графический дизайн', 'Grafik dizayn'],
    ['Бухгалтерский учёт', 'Buxgalteriya hisobi'],
    ['Экономика', 'Iqtisodiyot'],
    ['Право', 'Huquq'],
    ['Урок гитары', 'Gitara darsi'],
    ['Урок фортепиано', 'Fortepiano darsi'],
    ['Вокал', 'Vokal'],
    ['Урок дутара', 'Dutor darsi'],
    ['Урок рубаба', 'Rubob darsi'],
    ['Урок шахмат', 'Shaxmat darsi'],
    ['Урок рисования', 'Rasm darsi'],
    ['Чтение Корана', 'Qurʼon oʻqishni oʻrgatish'],
    ['Таджвид', 'Tajvid'],
    ['Консультация', 'Maslahat'],
    ['Пробное занятие', 'Sinov mashgʻuloti'],
    ['Занятие в мини-группе', 'Mini-guruhda dars'],
    ['Урок на дому', 'Uyda dars'],
    ['Выезд к ученику', 'Oʻquvchining uyiga borib dars'], // ?
    ['Интенсив', 'Intensiv kurs'],
  ],
  vet: [
    ['Первичный приём', 'Birlamchi qabul'],
    ['Повторный приём', 'Takroriy qabul'],
    ['Осмотр собаки', 'Itni koʻrikdan oʻtkazish'],
    ['Осмотр кошки', 'Mushukni koʻrikdan oʻtkazish'],
    ['Онлайн-консультация', 'Onlayn maslahat'],
    ['Консультация по питанию', 'Oziqlantirish boʻyicha maslahat'],
    ['Комплексная вакцинация', 'Kompleks emlash'],
    ['Прививка собаке', 'Itni emlash'],
    ['Прививка кошке', 'Mushukni emlash'],
    ['Кастрация собаки', 'Itni kastratsiya qilish'],
    ['Стерилизация собаки', 'Itni sterilizatsiya qilish'],
    ['Обработка от клещей', 'Kanaga qarshi ishlov berish'],
    ['Обработка от глистов', 'Gijjaga qarshi dori berish'],
    ['Удаление клеща', 'Kanani olib tashlash'],
    ['Укол', 'Ukol'],
    ['Инъекция', 'Inyeksiya'],
    ['Общий анализ крови', 'Umumiy qon tahlili'],
    ['Биохимия крови', 'Qon bioximiyasi'],
    ['Анализ мочи', 'Siydik tahlili'],
    ['Анализ кала', 'Najas tahlili'],
    ['Соскоб кожи', 'Teri qirindisi tahlili'], // ?
    ['Экспресс-тест', 'Ekspress-test'],
    ['УЗИ брюшной полости', 'Qorin boʻshligʻi UTT'],
    ['ЭКГ', 'EKG'],
    ['Лечение', 'Davolash'],
    ['Лечение дерматита', 'Dermatitni davolash'],
    ['Лечение ушей', 'Quloqni davolash'],
    ['Лечение глаз', 'Koʻzni davolash'],
    ['Лечение переломов', 'Singan suyakni davolash'],
    ['Обработка раны', 'Jarohatga ishlov berish'],
    ['Перевязка', 'Bogʻlash'],
    ['Наложение швов', 'Chok solish'],
    ['Снятие швов', 'Chokni olish'],
    ['Удаление опухоли', 'Oʻsmani olib tashlash'],
    ['Кесарево сечение', 'Kesar kesish'], // ?
    ['Помощь при родах', 'Tugʻishda yordam'],
    ['Наркоз', 'Narkoz'],
    ['Стационар', 'Statsionar'],
    ['Передержка', 'Hayvonni vaqtincha saqlash'], // ?
    ['Эвтаназия', 'Evtanaziya'],
    ['Кремация', 'Krematsiya'],
    ['Стрижка когтей', 'Tirnoq olish'],
    ['Чистка ушей', 'Quloq tozalash'],
    ['Чистка параанальных желёз', 'Paraanal bezlarni tozalash'],
    ['Ультразвуковая чистка зубов', 'Tishni ultratovush bilan tozalash'],
    ['Удаление зуба', 'Tish sugʻurish'],
    ['Ветеринарная справка', 'Veterinariya maʼlumotnomasi'],
    ['Справка для вывоза за границу', 'Chet elga olib chiqish uchun maʼlumotnoma'],
    ['Лечение птиц', 'Qushlarni davolash'],
    ['Лечение грызунов', 'Kemiruvchilarni davolash'],
    ['Экзотические животные', 'Ekzotik hayvonlar'],
    ['Лечение скота', 'Chorva mollarini davolash'],
    ['Вакцинация скота', 'Chorva mollarini emlash'],
    ['Искусственное осеменение', 'Sunʼiy urugʻlantirish'],
  ],
  grooming: [
    ['Груминг', 'Gruming'],
    ['Груминг собаки', 'Itni gruming qilish'],
    ['Груминг кошки', 'Mushukni gruming qilish'],
    ['Груминг щенка', 'Kuchukni gruming qilish'],
    ['Первый груминг щенка', 'Kuchukning birinchi grumingi'],
    ['Груминг котёнка', 'Mushukchani gruming qilish'],
    ['Груминг кролика', 'Quyonni gruming qilish'],
    ['Комплекс для мелких пород', 'Kichik zotli itlar uchun kompleks'],
    ['Стрижка мелкой собаки', 'Kichik itni qirqish'],
    ['Стрижка крупной собаки', 'Katta itni qirqish'],
    ['Стрижка шпица', 'Shpitsni qirqish'],
    ['Стрижка йорка', 'Yorkni qirqish'],
    ['Стрижка пуделя', 'Pudelni qirqish'],
    ['Стрижка под машинку', 'Mashinkada qirqish'],
    ['Стрижка ножницами', 'Qaychida qirqish'],
    ['Модельная стрижка', 'Model qirqish'],
    ['Породная стрижка', 'Zotiga mos qirqish'],
    ['Стрижка шерсти', 'Jun qirqish'],
    ['Стрижка лап', 'Panjalarni qirqish'],
    ['Стрижка морды', 'Tumshuqni qirqish'],
    ['Стрижка между подушечками', 'Panja yostiqchalari orasini qirqish'],
    ['Стрижка кота под льва', 'Mushukni sher shaklida qirqish'],
    ['Стрижка кошки без седации', 'Mushukni sedatsiyasiz qirqish'], // ?
    ['Стрижка когтей собаке', 'Itning tirnogʻini olish'],
    ['Стрижка когтей кошке', 'Mushukning tirnogʻini olish'],
    ['Подпил когтей', 'Tirnoqni egovlash'],
    ['Антицарапки', 'Tirnoq qoplamalari (antitsarapki)'], // ?
    ['Мытьё крупной собаки', 'Katta itni choʻmiltirish'],
    ['Мытьё мелкой собаки', 'Kichik itni choʻmiltirish'],
    ['Мытьё лап', 'Panja yuvish'],
    ['Сушка', 'Quritish'],
    ['Сушка и расчёсывание', 'Quritish va tarash'],
    ['Вычёсывание подшёрстка', 'Ichki junni tarash'],
    ['Удаление подшёрстка', 'Ichki junni olib tashlash'],
    ['Удаление колтунов', 'Chigallarni olib tashlash'],
    ['Маска для шерсти', 'Jun uchun niqob'],
    ['Кондиционер для шерсти', 'Jun uchun konditsioner'],
    ['SPA для собак', 'Itlar uchun SPA'],
    ['SPA-уход', 'SPA parvarish'],
    ['Чистка глаз', 'Koʻzni tozalash'],
    ['Обработка лап', 'Panjalarga ishlov berish'],
    ['Обработка от блох', 'Burgaga qarshi ishlov berish'],
    ['Чистка зубов ультразвуком', 'Tishni ultratovush bilan tozalash'],
    ['Окрашивание шерсти', 'Junni boʻyash'],
    ['Креативный груминг', 'Kreativ gruming'],
    ['Выезд грумера на дом', 'Grumerni uyga chaqirish'],
    ['Зоотакси', 'Uy hayvoni uchun taksi'], // ?
  ],
  doctor: [
    ['Приём терапевта', 'Terapevt qabuli'],
    ['Приём педиатра', 'Pediatr qabuli'],
    ['Приём гинеколога', 'Ginekolog qabuli'],
    ['Приём уролога', 'Urolog qabuli'],
    ['Консультация уролога', 'Urolog maslahati'],
    ['Консультация гастроэнтеролога', 'Gastroenterolog maslahati'],
    ['Консультация дерматолога', 'Dermatolog maslahati'],
    ['Консультация ЛОРа', 'LOR maslahati'],
    ['Консультация окулиста', 'Koʻz shifokori maslahati'],
    ['Консультация офтальмолога', 'Oftalmolog maslahati'],
    ['Консультация хирурга', 'Jarroh maslahati'],
    ['Консультация травматолога', 'Travmatolog maslahati'],
    ['Консультация ортопеда', 'Ortoped maslahati'],
    ['Консультация психолога', 'Psixolog maslahati'],
    ['Консультация психиатра', 'Psixiatr maslahati'],
    ['Консультация аллерголога', 'Allergolog maslahati'],
    ['Консультация пульмонолога', 'Pulmonolog maslahati'],
    ['Консультация нефролога', 'Nefrolog maslahati'],
    ['Консультация онколога', 'Onkolog maslahati'],
    ['Консультация маммолога', 'Mammolog maslahati'],
    ['Консультация ревматолога', 'Revmatolog maslahati'],
    ['Консультация диетолога', 'Dietolog maslahati'],
    ['Консультация проктолога', 'Proktolog maslahati'],
    ['Консультация андролога', 'Androlog maslahati'],
    ['Консультация по результатам анализов', 'Tahlil natijalari boʻyicha maslahat'],
    ['Второе мнение', 'Ikkinchi fikr'], // ?
    ['Вызов педиатра на дом', 'Pediatrni uyga chaqirish'],
    ['Медсестра на дом', 'Hamshirani uyga chaqirish'],
    ['Капельница на дому', 'Uyda tomchilatib yuborish'],
    ['Ведение беременности', 'Homiladorlikni kuzatish'],
    ['УЗИ беременности', 'Homiladorlik UTT'],
    ['УЗИ брюшной полости', 'Qorin boʻshligʻi UTT'],
    ['УЗИ щитовидной железы', 'Qalqonsimon bez UTT'],
    ['УЗИ почек', 'Buyrak UTT'],
    ['УЗИ малого таза', 'Kichik chanoq UTT'],
    ['УЗИ сердца', 'Yurak UTT (ExoKG)'],
    ['Холтер', 'Xolter monitoring'],
    ['Суточный мониторинг давления', 'Qon bosimini sutkalik monitoring qilish'],
    ['Спирометрия', 'Spirometriya'],
    ['ФГДС', 'FGDS'],
    ['Колоноскопия', 'Kolonoskopiya'],
    ['Комплексное обследование', 'Kompleks tekshiruv'],
    ['Забор крови', 'Qon olish'],
    ['Мазок', 'Surtma olish'],
    ['Общий анализ крови', 'Umumiy qon tahlili'],
    ['Анализ мочи', 'Siydik tahlili'],
    ['Анализ на гормоны', 'Gormonlar tahlili'],
    ['Анализ на сахар', 'Qand tahlili'],
    ['Внутримышечный укол', 'Mushak ichiga ukol'],
    ['Внутривенный укол', 'Vena ichiga ukol'],
    ['Прививка', 'Emlash'],
    ['Удаление бородавок', 'Soʻgalni olib tashlash'],
    ['Удаление папиллом', 'Papillomani olib tashlash'],
    ['Вскрытие фурункула', 'Chipqonni ochish'],
    ['Снятие швов', 'Chokni olish'],
    ['Промывание ушей', 'Quloqni yuvish'],
    ['Удаление серной пробки', 'Quloq tiqinini olib tashlash'],
    ['Физиотерапия', 'Fizioterapiya'],
    ['ЛФК', 'Davolash jismoniy tarbiyasi (DJT)'], // ?
    ['Иглорефлексотерапия', 'Igna bilan davolash'],
    ['Медицинская справка', 'Tibbiy maʼlumotnoma'],
    ['Справка для водительских прав', 'Haydovchilik guvohnomasi uchun maʼlumotnoma'],
    ['Больничный лист', 'Kasallik varaqasi'],
    ['Выписка рецепта', 'Retsept yozib berish'],
  ],
};
